import call from "./call";
import { getAuthDataFromState } from "../utils";
import { SET_AUDIT_INFO } from "../types";

/**
 * Consulta el reporte de auditoría en el backend y almacena la información en el store.
 * @param {Object} reportValues Filtros del formulario (ej. customer, range).
 */
const getAuditReport = (reportValues) => async (dispatch, getState) => {
    const data = getAuthDataFromState(dispatch, getState);
    if (!data) return;

    const onResult = (result) => {
        dispatch({ type: SET_AUDIT_INFO, payload: result });
    };

    dispatch(call("Service/getAuditReport", { ...data, reportValues }, onResult));
};

export default getAuditReport;
